declare var $: any;
declare var Chart: any;
declare var graphData: any;

export class PrognosisGraph {

    private static fontFamily = "'Futura LT', 'futura-pt', 'Open Sans'";
    private static fontBodyColor = "#231F20";
    private static gridLineColor = "#CCCCCC";
    private static axesColor = "#222222";

    static init() {
        PrognosisGraph.drawChart(graphData);

        $(".js-prognosis-graph").on("graphReloaded",
            (event: Event, json: any) => {
                event.preventDefault();
                PrognosisGraph.drawChart(json);
            });
    }

    static drawChart(data: any) {
        const ctx = $("#prognosisGraph");
        return new Chart(ctx,
            {
                type: "line",
                data: data,
                options: {
                    scales: PrognosisGraph.getScaleSettings(),
                    legend: PrognosisGraph.getLegendSettings(),
                    tooltips: PrognosisGraph.getTooltipSettings()
                }
            });
    }

    static getLegendSettings() {
        return {
            position: "bottom",
            labels: {
                padding: 20,
                boxWidth: 15,
                fontColor: PrognosisGraph.fontBodyColor,
                fontSize: 16,
                fontFamily: PrognosisGraph.fontFamily
            },
            onHover: function (event: Event, legendItem: any) {
                event.preventDefault();
                $(event.target).css({ cursor: "pointer" });
            }
        };
    }

    static getTooltipSettings() {
        return {
            backgroundColor: "rgba(1,1,1,0)",
            bodyFontColor: PrognosisGraph.fontBodyColor,
            bodyFontSize: 16,
            bodyFontFamily: PrognosisGraph.fontFamily,
            displayColors: false,
            callbacks: {
                title: function (tooltipItems: any, data: any) {
                    return "";
                },
                label: function (tooltipItem: any, data: any) {
                    return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                }
            }
        };
    }

    static getScaleSettings() {
        return {
            yAxes: [
                {
                    scaleLabel: {
                        display: true,
                        labelString: 'Tkr'
                    },
                    ticks: {
                        beginAtZero: true,
                        fontColor: PrognosisGraph.axesColor,
                        fontSize: 16,
                        fontFamily: PrognosisGraph.fontFamily,
                        callback: function (value: number) {
                            return value.toLocaleString('sv');
                        }
                    },
                    gridLines: {
                        color: "rgba(1,1,1,0)",
                        zeroLineColor: PrognosisGraph.axesColor,
                        zeroLineWidth: 1.5
                    }
                }
            ],
            xAxes: [
                {
                    position: "top",
                    ticks: {
                        fontColor: PrognosisGraph.axesColor,
                        fontSize: 14,
                        fontFamily: PrognosisGraph.fontFamily
                    },
                    gridLines: {
                        color: PrognosisGraph.gridLineColor,
                        lineWidth: 0.4,
                        zeroLineColor: PrognosisGraph.axesColor,
                        zeroLineWidth: 1.5,
                        drawBorder: false
                    }
                }
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/partials/prognosisGraph.ts